<template>
  <div class="booksindex-content" :class="collapsed==1?'ml-0':'ml-190'">
    <div class="booksindex-lesson-search">
      <div class="booksindex-lesson-search-inner">
        <div class="booksindex-lesson-search-left">
          <a-input
            v-model="lessonSearchKeyword"
            allow-clear
            placeholder="输入课文名称搜索"
            class="booksindex-lesson-search-input"
            @pressEnter="runLessonSearch(true)"
            @focus="onLessonSearchFocus"
            @blur="onLessonSearchBlur"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button type="primary" class="booksindex-lesson-search-btn" @click="runLessonSearch(true)">
            搜索
          </a-button>
        </div>
        <div
          v-if="lessonSearchHistory.length"
          class="booksindex-lesson-search-history"
        >
          <span class="booksindex-lesson-search-history-label">搜索记录：</span>
          <div class="booksindex-lesson-search-history-tags">
            <span
              v-for="(kw, idx) in lessonSearchHistory"
              :key="'h-' + idx + '-' + kw"
              class="booksindex-history-tag"
            >
              <span class="booksindex-history-tag-text" @mousedown.prevent="useLessonSearchHistory(kw)">{{ kw }}</span>
              <a-icon
                type="close"
                class="booksindex-history-tag-close"
                @mousedown.prevent.stop="removeLessonSearchHistoryAt(idx)"
              />
            </span>
          </div>
          <a href="javascript:;" class="booksindex-history-clear" @mousedown.prevent="clearLessonSearchHistory">
            <a-icon type="delete" />
            清空记录
          </a>
        </div>
      </div>
      <div
        v-show="lessonSearchDropdownVisible && (lessonSearchLoading || lessonSearchResults.length || lessonSearchNoResult)"
        class="booksindex-lesson-search-dropdown"
      >
        <a-spin v-if="lessonSearchLoading" size="small" class="booksindex-lesson-search-spin" />
        <template v-else>
          <div class="booksindex-lesson-search-label">课文</div>
          <div
            v-for="row in lessonSearchResults"
            :key="row.id"
            class="booksindex-lesson-search-item"
            @mousedown.prevent="onLessonSearchPick(row)"
          >
            <div class="booksindex-lesson-search-item-body">
              <span class="booksindex-lesson-search-item-title">{{ lessonSearchRowTitle(row) }}</span>
              <span
                v-if="lessonSearchRowMeta(row)"
                class="booksindex-lesson-search-item-meta"
              >{{ lessonSearchRowMeta(row) }}</span>
            </div>
          </div>
          <div v-if="lessonSearchNoResult" class="booksindex-lesson-search-empty">
            暂无匹配课文
          </div>
        </template>
      </div>
    </div>
    <div class="booksindex-main">
      <div class="imagelist">
      <div class="ImageItem" v-for="(item, index) in books" :key="item.id">
        <img :src="$resBasePath + item.photoPath"
             :class="{ normal: true, big: bookId === item.id ,lockgray:item.isBuy === 0}"
             @click="changeActiveImage(item, index)"/>
        <han-icon v-if="item.isBuy === 0" type="lockIcon" :class="{ lock: true, biglock: bookId == item.id}"
                  @click="changeActiveImage(item, index)"/>
        <div class="book-name" :class="{'book-name-select': bookId === item.id }">
          <span>{{ item.name }}</span>
          <img class="img_1" src="../../assets/image/bookmicro.png" style="width:20px;height:20px"
               @click="openClick(item.id)"/>
        </div>
      </div>
      </div>
      <div class="catalog">
      <div class="catalog-title">
        <span class="catalog-text"> 目录</span>
        <div class="catalog-style">
          <a-radio-group v-model="catalogShow" @change="handleChange" defaultValue="列表">
            <a-radio-button value="列表" style="background-image: url('../../assets/image/book_unit.png')">
              <a-icon type="unordered-list" style="height: 10px;width: 10px"/>
            </a-radio-button>
            <a-radio-button value="卡片">
              <a-icon type="appstore" style="height: 10px;width: 10px"/>
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="catalog-content" v-show="catalogShow==='列表'">
        <div :class="{ title: item.elementName == 1, 'catalog-content-i': true }"
             v-for="(item) in shareData.menuList" :key="item.id">
          <span v-if="item.isFree === 1 && item.elementName != 1" class="isClickable"
                @click="goToLearnPre(item)">
            {{ item.displayName }}
          </span>
          <div v-else class="disabled">
             <span :class="{ 'disabledxxx': item.elementName == 1 }"
                   :style="item.elementName != 1 ? 'padding-left:30px;' : ''" @click="goToLearnPre(item)">
              {{ item.displayName }}
             </span>
            <div class="card-video" v-show="item.elementName == 1" @click="openMicroLessonDialog(item)"/>
            <div class="card-herf" v-show="item.elementName == 1" @click="openDialog(item)"/>
          </div>
        </div>
      </div>
      <div class="catalog-list" v-show="catalogShow==='卡片'">
        <a-list :data-source="processedData" :grid="{ gutter: 16, column:4 }">
          <a-list-item slot="renderItem" slot-scope="unit, index">
            <a-card :title="unit.displayName" :hoverable=true :bordered=false
                    :class="{'card':unit.bookId==='1','card2':unit.bookId==='2','card3':(unit.bookId!=='1'&&unit.bookId!=='2')}">
              <template slot="extra" class="card-extra">
                <div class="card-video" @click="openMicroLessonDialog(unit)"/>
                <div class="card-herf" @click="openDialog(unit)"/>
              </template>
              <div :class="{ title: item.elementName == 1, 'catalog-content-i': true }"
                   v-for="(item) in unit" :key="item.id" style="padding-top:8px;">
                  <span v-if="item.isFree === 1 && item.elementName != 1" class="isClickable"
                        style="white-space: pre-wrap;" @click="goToLearnPre(item)">
                  {{ item.displayName }}
                  </span>
                <span v-else class="disabled" :class="{ 'disabledxxx': item.elementName == 1 }"
                      :style="item.elementName != 1 ? 'padding-left:30px;' : ''" @click="goToLearnPre(item)">
                      {{ item.displayName }}
                </span>
              </div>
            </a-card>
          </a-list-item>
        </a-list>
      </div>
      </div>
    </div>
    <a-modal title="单元导学" v-model="subject" :footer="null" width="850px" centered>
      <a-spin class="load" v-show="loading"/>
      <div class="top">
        <div class="left" v-if="unitGuideData">
          <div class="dialog">
            <div class="dialog-content-title">
              <span>{{ unitGuideData && unitGuideData.unitTitle }}</span>
            </div>
            <div class="dialog-content-title-i">

              <span>{{ unitGuideData && unitGuideData.title }}</span>
            </div>

          </div>
          <div class="dialog-content-ii">
            <p>{{ unitGuideData && unitGuideData.unitIntroductionContent }}</p>
          </div>

          <div class="dialog-content-title-i">
            <span>{{ unitGuideData && unitGuideData.subjectTitle }}</span>
          </div>

          <div class="dialog-content-ii">
            <div v-for="(item, index) in unitGuideData && unitGuideData.subjectContents" :key="index">
              <h4 v-if="item.format === 1"><b>{{ item.content }}</b></h4>
              <p v-if="item.format === 0">
                <img
                    style="width:12px;height:12px;background: @primary-color;background-size: cover;border-radius: 50%;margin-top: -6px"/>
                {{ item.content }}
              </p>
            </div>
          </div>
          <div class="dialog-content-title-i">
            <span>{{ unitGuideData && unitGuideData.studyGoalTitle }}</span>
          </div>
          <div class="dialog-content-ii">
            <div style="text-align: center"
                 v-if="unitGuideData && unitGuideData.studyGoalContents && unitGuideData.studyGoalContents.length > 1">
              <a-radio-group v-model="studyGoalContentIndex" button-style="solid">
                <a-radio-button style="padding:0 30px" :value="index"
                                v-for="(item, index) in unitGuideData && unitGuideData.studyGoalContents"
                                :key="index">
                  {{ item.title }}
                </a-radio-button>
              </a-radio-group>
            </div>
            <div v-show="studyGoalContentIndex === index"
                 v-for="(item, index) in unitGuideData && unitGuideData.studyGoalContents" :key="index"
                 style="white-space: pre-line">
              <h4 class="tabTitle">{{ item.languageGoalTitle }}</h4>
              <div>{{ item.languageGoalContent }}</div>
              <h4 class="tabTitle">{{ item.thinkingGoalTitle }}</h4>
              <div>{{ item.thinkingGoalContent }}</div>
              <h4 class="tabTitle">{{ item.valueGoalTitle }}</h4>
              <div>{{ item.valueGoalContent }}</div>
            </div>
          </div>
        </div>
        <div class="empty" style="margin:200px auto" v-else>
          <a-empty/>
        </div>
      </div>
    </a-modal>
    <a-modal title="微课" v-model="mlVisibles" :footer="null" width="900px" centered :destroyOnClose=true>
      <div v-if="microLesson[0]">
        <video width="100%" v-if="microLesson[0].videoPath.split('.')[1] == 'mp4'" controlslist="nodownload"
               :disablePictureInPicture="true" :src="$resBaseVideo + '/' + microLesson[0].videoPath"
               controls="controls" :poster="$resBasePath + microLesson[0].videoPhotoCover"></video>
        <ts-video v-if="microLesson[0].videoPath.split('.')[1] == 'm3u8'" ref="myVideo" width="90%"
                  :poster="$resBasePath + microLesson[0].videoPhotoCover"
                  :vPath="$resBaseVideo + microLesson[0].videoPath">
        </ts-video>
      </div>
      <div v-if="!microLesson[0]">
        <div class="d-table">
          <img class="no-data" src="../../assets/image/no-data.png" alt=""/>
          <div>
            <span style="font-size: 16px">暂无单元微课视频</span>
          </div>

        </div>
      </div>
    </a-modal>

    <a-modal title="购买教材" v-model="buyVisibles" :footer="null" width="600px" centered :destroyOnClose=true
             :maskClosable="false" @cancel="buyClose">
      <div v-if="false">
        <div class="flex-row justify-between">
          <div class="buy-title">商品信息</div>

          <a-dropdown placement="bottomRight" v-show="productData.length>1">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" style="color: #000000">
              {{ selectedText }}
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay" style="background:rgba(0, 0, 0, 0.8);" @click="onClickChoiceBook">
              <a-menu-item v-for="(item, index) in productData " :key="index" class="a-menu-item">
                {{ item.name }}
              </a-menu-item>

              <!--              <a-menu-item key="0" class="a-menu-item">-->
              <!--                全五册-->
              <!--              </a-menu-item>-->
              <!--              <a-menu-divider/>-->
              <!--              <a-menu-item key="1" class="a-menu-item">-->
              <!--                必修上册-->
              <!--              </a-menu-item>-->
              <!--              <a-menu-divider/>-->
              <!--              <a-menu-item key="2" class="a-menu-item">-->
              <!--                必修下册-->
              <!--              </a-menu-item>-->
              <!--              <a-menu-divider/>-->
              <!--              <a-menu-item key="3" class="a-menu-item">-->
              <!--                选择性必修上册-->
              <!--              </a-menu-item>-->
              <!--              <a-menu-divider/>-->
              <!--              <a-menu-item key="4" class="a-menu-item">-->
              <!--                选择性必修中册-->
              <!--              </a-menu-item>-->
              <!--              <a-menu-divider/>-->
              <!--              <a-menu-item key="5" class="a-menu-item">-->
              <!--                选择性必修下册-->
              <!--              </a-menu-item>-->
            </a-menu>
          </a-dropdown>
        </div>
        <div class="buy-info mt-10">
          <div class="info-container">
            <div class="left-div">
              <img class="info-img" :src="$resBasePath + selectedProduct.photoPath"/>
            </div>
            <div class="right-div">
              <div class="top-div">
                <span class="info-status">支持开发票</span>
              </div>
              <div class="middle-div">
                <p class="buy-title">{{ selectedProduct.name }}</p>
                <p class="info-price">¥ {{ selectedProduct.price }}/年</p>
              </div>
              <div class="bottom-div">
                <p class="buy-content">{{ selectedProduct.purchaseDescription }}</p>
              </div>
            </div>
          </div>

        </div>
        <div class="buy-title mt-20">填写基本信息</div>
        <div class="flex-row mt-10">
          <div class="flex-row flex-grow">
            <span class="info-must">*</span>
            <span class="info-title "> 姓名：</span>
            <a-input v-model="customName" class="info-content" placeholder="请输入真实姓名"
                     :allowClear="true"></a-input>
          </div>
          <div class="flex-row flex-grow ml-20" style="position: relative">
            <span class="info-must">*</span>
            <span class="info-title"> 身份证号：</span>
            <a-input v-model="customNo" placeholder="请输入身份证号" @change="onContentChange"></a-input>
            <a-tooltip placement="top" title="不满18周岁禁止自主购买">
              <!--            <a-button class="info-tips" type="primary" shape="circle" icon="exclamation-circle"></a-button>-->
              <a-icon type="exclamation-circle" class="info-tips"/>
            </a-tooltip>
          </div>
        </div>
        <div class="flex-row mt-10">
          <div class="flex-row flex-grow" style="visibility: hidden">
            <span class="info-title"> </span>
            <span class="info-title"> </span>
            <span class="info-title"> </span>
            <span class="info-title"> </span>
          </div>
          <div class="flex-row flex-grow">
            <span class="info-must" style="font-size: 12px;">{{ contentTips }}</span>
          </div>
        </div>
        <div class="buy-title mt-20">支付方式</div>
        <div class="flex-row flex-grow ml-20">
          <div class=" mt-10" style="width:140px;height:80px;cursor: pointer;" @click="gotoPay(1)">
            <img class="buy-img" src="../../assets/image/pay-ali.png" v-if="!showAliQrcode"/>
            <img class="buy-img" src="../../assets/image/pay-ali-selected.png" v-if="showAliQrcode"/>
          </div>
          <div class=" mt-10" style="width:140px;height:80px;cursor: pointer;" @click="gotoPay(2)">
            <img class="buy-img" src="../../assets/image/pay-wechat.png" v-if="!showWechatQrcode"/>
            <img class="buy-img" src="../../assets/image/pay-chat-selected.png" v-if="showWechatQrcode"/>
          </div>
        </div>
        <div v-if="showQrcode">
          <a-spin tip="加载中..." :spinning="showQrcodeLoading">
            <div style="text-align: center;font-size: small;margin-top: -20px">扫描下方二维码完成支付</div>
            <div style="text-align: center" class="pb-1">
              <div class="qrcode-content" ref="qrcode" style="border:none;margin-top: 10px"></div>
            </div>
            <div style="text-align: center;font-size: small;margin-top: 10px">
              <a-statistic-countdown
                  prefix="请在"
                  suffix="内完成支付，否则订单会自动取消"
                  :value="(currentOrder.crateDate+ 1800000 )||1717491350000"
                  class="a-statistic-countdown"
                  format="mm:ss"/>
            </div>
          </a-spin>
        </div>
      </div>
      <div v-if="true">
        <div class="d-table">
          <img class="no-data" src="../../assets/image/no-data.png" alt=""/>
          <div>
            <span style="font-size: 16px"> 请联系管理员开通教材</span>
          </div>

        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import shareState from '../../utils/shareState.js'
import HanIcon from 'components/Icon.vue'
import tsVideo from './components/tsvideo.vue'
import QRCode from 'qrcodejs2'
import AuthUtils from '../../utils/AuthUtils.js'
import { debounce } from 'lodash'
// import http from '../../utils/http.js'

const setUserInfo = user => {
  let userStr = null
  try {
    userStr = JSON.stringify(user)
  } catch (e) {
  }
  userStr && window.localStorage.setItem('user_info', userStr)
}
export default {
  name: 'IndexContent',
  components: {
    HanIcon,
    tsVideo
  },
  created () {
    this.lessonSearchHistory = this.loadLessonSearchHistoryFromStorage()
    this.getBooks()
    this.debouncedLessonSearch = debounce(() => {
      this.runLessonSearch(false)
    }, 300)
  },
  data () {
    return {
      catalogShow: '列表', // 列表显示样式
      subject: false, // 学科素养
      styleId: '',
      encryptionKey: '',
      bookId: localStorage.getItem('syzg-bookId') || '1',
      books: [],
      shareData: shareState.state,
      visible: false,
      collapsed: localStorage.getItem('LessonCollapsed'),
      mlVisible: false,
      mlVisibles: false,
      microLessonDate: {},
      microLesson: [],
      processedData: [],
      hls: '',
      unitGuideData: {},
      selectedProduct: {},
      studyGoalContentIndex: 0,
      loading: true,
      showQrcode: false,
      showQrcodeLoading: false,
      showWechatQrcode: false,
      showAliQrcode: false,
      payType: 1,
      bookIndex: 0,
      T: '', // 定时器的ID
      productData: [],
      customName: '',
      customNo: '',
      access_token: localStorage.getItem('access_token'),
      buyVisibles: false,
      selectedText: '选择教材', // 初始文本
      contentTips: '', // 初始文本
      qrcode: null,
      currentOrder: {},
      lessonSearchKeyword: '',
      lessonSearchResults: [],
      lessonSearchLoading: false,
      lessonSearchDropdownVisible: false,
      lessonSearchNoResult: false,
      lessonSearchHistory: [],
      bookList: [
        {
          id: '1',
          name: '全五册'
        },
        {
          id: '2',
          name: '必修上册'
        },
        {
          id: '3',
          name: '必修下册'
        },
        {
          id: '4',
          name: '选择性必修上册'
        },
        {
          id: '4',
          name: '选择性必修中册'
        },
        {
          id: '4',
          name: '选择性必修下册'
        }
      ]
    }
  },
  watch: {
    mlVisible () {
      if (!this.mlVisible) {
        this.$refs.myVideo.vPause()
      }
    },
    $route () {
      this.collapsed = localStorage.getItem('LessonCollapsed')
      console.log('route变化-目录-', this.collapsed)
    },
    collapsed (newValue, oldValue) {
      console.log('collapsed变化-目录-', newValue)
      console.log('collapsed变化-目录-', oldValue)
    },
    lessonSearchKeyword (val) {
      const t = (val || '').trim()
      if (!t) {
        this.lessonSearchResults = []
        this.lessonSearchLoading = false
        this.lessonSearchNoResult = false
        return
      }
      this.lessonSearchDropdownVisible = true
      this.debouncedLessonSearch()
    }

  },
  mounted () {
    this.changeWight()
    // this.getPublicSecret()
  },
  methods: {
    onLessonSearchFocus () {
      this.lessonSearchDropdownVisible = true
      if ((this.lessonSearchKeyword || '').trim()) {
        this.runLessonSearch(false)
      }
    },
    onLessonSearchBlur () {
      setTimeout(() => {
        this.lessonSearchDropdownVisible = false
      }, 200)
    },
    findMenuItemByStyleId (styleId) {
      const sid = String(styleId)
      const menu = this.shareData.menuList || []
      for (const item of menu) {
        if (String(item.id) === sid) return item
        const subs = item.completeBookList
        if (subs && subs.length) {
          const hit = subs.find((s) => String(s.id) === sid)
          if (hit) {
            return Object.assign({}, item, hit, {
              id: hit.id,
              orgDisplayName: hit.orgDisplayName || hit.displayName,
              isFree: hit.isFree !== undefined && hit.isFree !== null ? hit.isFree : item.isFree
            })
          }
        }
      }
      return null
    },
    loadLessonSearchHistoryFromStorage () {
      try {
        const raw = localStorage.getItem('sygz-lesson-search-history')
        if (!raw) return []
        const arr = JSON.parse(raw)
        if (!Array.isArray(arr)) return []
        return arr.filter((k) => typeof k === 'string' && k.trim()).slice(0, 30)
      } catch (e) {
        return []
      }
    },
    persistLessonSearchHistory () {
      try {
        localStorage.setItem('sygz-lesson-search-history', JSON.stringify(this.lessonSearchHistory))
      } catch (e) {}
    },
    pushLessonSearchHistory (keyword) {
      const k = (keyword || '').trim()
      if (!k) return
      let list = this.lessonSearchHistory.filter((item) => item !== k)
      list.unshift(k)
      if (list.length > 20) list = list.slice(0, 20)
      this.lessonSearchHistory = list
      this.persistLessonSearchHistory()
    },
    removeLessonSearchHistoryAt (index) {
      if (index < 0 || index >= this.lessonSearchHistory.length) return
      this.lessonSearchHistory.splice(index, 1)
      this.persistLessonSearchHistory()
    },
    clearLessonSearchHistory () {
      this.lessonSearchHistory = []
      try {
        localStorage.removeItem('sygz-lesson-search-history')
      } catch (e) {}
    },
    useLessonSearchHistory (kw) {
      this.lessonSearchKeyword = kw
      this.runLessonSearch(true)
    },
    lessonSearchRowTitle (row) {
      if (!row) return ''
      if (row.orgDisplayName) return row.orgDisplayName
      const d = row.displayName
      if (d == null || d === '') return ''
      const s = String(d).replace(/^\s*\d+\s*/, '').trim()
      return s || String(d)
    },
    lessonSearchRowMeta (row) {
      if (!row) return ''
      const parts = []
      if (row.bookName != null && String(row.bookName).trim() !== '') {
        parts.push(String(row.bookName).trim())
      }
      if (row.cellName != null && String(row.cellName).trim() !== '') {
        parts.push(String(row.cellName).trim())
      }
      return parts.join(' · ')
    },
    runLessonSearch (saveToHistory = false) {
      const name = (this.lessonSearchKeyword || '').trim()
      if (!name) {
        this.lessonSearchResults = []
        this.lessonSearchLoading = false
        this.lessonSearchNoResult = false
        return
      }
      this.lessonSearchLoading = true
      this.lessonSearchNoResult = false
      this.lessonSearchDropdownVisible = true
      this.$fetch(
        {
          url: this.$baseUrl + 'ebook/book/getStyleListLikeByName',
          body: {
            access_token: this.access_token,
            name: name
          }
        },
        () => {
          this.lessonSearchLoading = false
          this.lessonSearchResults = []
          this.lessonSearchNoResult = true
        }
      ).done((res) => {
        this.lessonSearchLoading = false
        if (res && res.success && res.resultCode === 0 && res.resultData) {
          this.lessonSearchResults = res.resultData
          this.lessonSearchNoResult = res.resultData.length === 0
        } else {
          this.lessonSearchResults = []
          this.lessonSearchNoResult = true
        }
        if (saveToHistory && name) {
          this.pushLessonSearchHistory(name)
        }
      })
    },
    goToLearnPreBySearchRow (row) {
      const lessonTitle =
        row.orgDisplayName ||
        String(row.displayName || '')
          .replace(/^\s*\d+\s*/, '')
          .trim() ||
        row.displayName ||
        ''
      shareState.setStyleId(row.id)
      shareState.setOrgDisplayName(row.orgDisplayName || lessonTitle)
      localStorage.setItem('styleId', row.id)
      localStorage.setItem('lessonName', lessonTitle)
      localStorage.setItem('lessonNKey', 'Attainment')
      this.$store.commit('setStyleId', row.id)
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/lessonBook/setLessonRecordStatus',
        body: {
          userId: this.$getUserInfo().id,
          isTea: 1,
          styleId: row.id,
          access_token: this.access_token
        }
      }).done(() => {})
      this.$router.push({ path: `/books/attainment/${row.id}` })
    },
    onLessonSearchPick (row) {
      const keyword = (this.lessonSearchKeyword || '').trim()
      if (keyword) {
        this.pushLessonSearchHistory(keyword)
      }
      this.lessonSearchDropdownVisible = false
      this.lessonSearchKeyword = ''
      this.lessonSearchResults = []
      this.lessonSearchNoResult = false

      const item = this.findMenuItemByStyleId(row.id)
      if (item) {
        this.goToLearnPre(item)
      } else {
        this.goToLearnPreBySearchRow(row)
      }
    },
    handleChange (value) {
      this.catalogShow = value.target.value
    },
    openClick (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/study/findMicroVideoList',
        body: {
          bookId: id,
          microModule: 2
        }
      }).done((res) => {
        this.microLesson = res.resultData
        this.mlVisibles = true
      })
    },
    // 学科素养
    openDialog (item) {
      this.subject = true
      this.studyGoalContentIndex = 0
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/unit/getUnitGuidance',
        body: {
          access_token: this.access_token,
          userId: this.$getUserInfo().id,
          bookId: item.bookId,
          classId: '',
          styleId: item.id
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.loading = false
          this.unitGuideData = res.resultData
        }
      })
    },
    getBooks () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/myBookList',
        body: {
          purchaseVersion: 2
        }
      }).done((res) => {
        this.books = res.resultData.list
        const bookId = localStorage.getItem('syzg-bookId')
        if (bookId) {
          this.getCatalog(bookId)
        } else {
          this.bookId = this.books[0].id
          this.getCatalog(this.bookId)
        }
        this.$store.commit('setMyBookList', this.books)
        // this.isPurchase()
      })
    },
    // ebook/purchase/isPurchase
    // isPurchase () {
    //   const param = {
    //     bookId: localStorage.getItem('syzg-bookId'),
    //     userId: this.$getUserInfo().id,
    //     purchaseVersion: '2'
    //   }
    //   this.$fetch({
    //     url: this.$baseUrl + 'ebook/purchase/isPurchase',
    //     body:param
    //   }).done(res =>{
    //     if(res && res.resultCode === 0 && res.success){//接口有数据返回
    //       if(res.resultData==true){
    //         console.log('已经购买')
    //       }else{
    //         console.log('未购买')
    //       }
    //     }
    //   })
    // },
    changeActiveImage (item, index) {
      // isBuy 用户购买书是否有效 1 是 0 否
      console.log('selectedBook', item)
      if (item.isBuy === 1) {
        this.bookId = item.id
        this.bookIndex = index
        localStorage.setItem('syzg-bookId', this.bookId)
        this.getCatalog(this.bookId)
      } else {
        this.buyVisibles = true
        this.getProduct()
      }
    },
    getCatalog (id) {
      this.lessonSearchKeyword = ''
      this.lessonSearchResults = []
      this.lessonSearchNoResult = false
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/styleList',
        body: {
          bookId: id,
          purchaseVersion: 2
        }
      })
        .loading(() => (this.loading = true))
        .done((res) => {
          shareState.setMenuList(res.resultData)
          this.processedData = []
          const resultData = res.resultData
          for (let i = 0; i < resultData.length; i++) {
            const element = resultData[i]
            if (element.elementName === '1' && element.parentId !== '247') {
              // 屏蔽逻辑的力量  247
              const id = element.id
              const processedDatai = []
              processedDatai.displayName = element.displayName
              processedDatai.bookId = element.bookId
              processedDatai.id = element.id
              for (let j = 0; j < resultData.length; j++) {
                const subElement = resultData[j]

                if (subElement.parentId === id) {
                  processedDatai.push(subElement)
                }
              }
              this.processedData.push(processedDatai)
            }
          }

          // console.log(this.processedData)
        })
    },
    // getCatalog (id) {
    //   const param = {
    //     pageNum: '1',
    //     pageSize: '10',
    //     bookId: id,
    //     styleId: '37',
    //     school: '' // 教师所在学校
    //   }
    //   http.getRecommendList(param).then(res => {
    //     console.log(res)
    //   })
    // },
    goResources () {
      // this.studyGoalContentIndex = 0
      // this.$fetch({
      //   url: this.$baseUrl + 'ebook/unit/getUnitGuidance',
      //   body: {
      //     styleId: id
      //   }
      // }).done(res => {
      //   this.unitGuideData = res.resultData
      //   // console.log(this.unitGuideData)
      //   this.visible = true
      // })
      this.$router.push({ path: '/books/newLessonResources/' })
    },
    openMicroLessonDialog (item) {
      console.log(item)
      this.$fetch({
        url: this.$baseUrl + 'ebook/study/findMicroVideoList',
        body: {
          access_token: this.access_token,
          userId: this.$getUserInfo().id,
          bookId: item.bookId,
          classId: '',
          styleId: item.id,
          microModule: 3
        }
      }).done((res) => {
        this.microLesson = res.resultData
        this.mlVisibles = true
      })
    },
    goToLearnPre (item) {
      // 为了测试，放开点击判断条件，后续需要调整
      // if (Number(item.isClickable) === 0 || Number(item.isFree) === 0 || Number(item.id) === 28) return false

      // if (Number(item.isClickable) === 0) return false
      // shareState.setOrgDisplayName(item.orgDisplayName)
      // shareState.setAuthor(item.author)
      // shareState.setGenreType(item.genreType)
      // 是否免费 1： 是 0：否
      console.log('selectedStyle', item)
      if (item.isFree === 1) {
        shareState.setStyleId(item.id)
        localStorage.setItem('styleId', item.id)
        localStorage.setItem('lessonName', item.orgDisplayName)
        // 默认进入选择学科素养
        localStorage.setItem('lessonNKey', 'Attainment')
        // console.log('lessonNKey', localStorage.getItem('lessonNKey'))
        // console.log(localStorage.getItem('lessonName'))
        this.$store.commit('setStyleId', item.id)
        //  暂存备课信息
        this.$fetch({
          url: this.$baseUrl + 'ebook/teacher/lessonBook/setLessonRecordStatus',
          body: {
            userId: this.$getUserInfo().id,
            isTea: 1,
            styleId: item.id,
            access_token: this.access_token
          }
        }).done((res) => {
          if (res && res.data) {
            // console.log('备课')
          }
        })
        this.$router.push({ path: `/books/attainment/${item.id}` })
      } else {
        this.buyVisibles = true
        this.getProduct()
      }
      // if (item.completeBookList.length > 0) {
      //   shareState.setcompleteBookList(item.completeBookList)
      // }
      // if (item.genreType === 6) {
      //   this.$router.push({ path: '/books/active-unit/' })
      //   return
      // }
      // this.$router.push({ path: `/books/learning-pre/${item.id}` })
    },
    changeWight () {
      // setTimeout(() => {
      //
      // }, 1000)
      this.collapsed = localStorage.getItem('LessonCollapsed')
      console.log('collapsed-changeWight-', this.collapsed)
      this.$forceUpdate()
    },
    onClickChoiceBook ({ key }) {
      console.log(`Click on item ${key}`)
      const title = ['全五册', '必修上册', '必修下册', '选择性必修上册', '选择性必修中册', '选择性必修下册']
      this.selectedText = this.productData[key].name
      this.selectedProduct = this.productData[key]
      this.buyClose()
    },
    buyClose () {
      this.showQrcode = false
      this.showWechatQrcode = false
      this.showQrcodeLoading = false
      this.showAliQrcode = false
      this.showWechatQrcode = false
      this.qrcode = null
      if (this.T) {
        clearInterval(this.T)
      }
      this.T = null
    },
    gotoPay (index) {
      if (this.customName === '') {
        this.$message.error('请输入姓名')
        return
      }
      if (this.customNo === '') {
        this.contentTips = '*请输入身份证号'
        return
      }
      if (!this.isValidChineseID(this.customNo)) {
        this.$message.error('身份证号码格式不正确')
        return
      }
      if (!this.isAgeGreaterThan16(this.customNo)) {
        this.contentTips = ('不满18周岁禁止自主购买')
        return
      }
      // 二维码区域
      this.showQrcode = true
      // 加载进度条
      this.showQrcodeLoading = true

      // 支付方式
      this.payType = index
      if (this.T) {
        clearInterval(this.T)
      }
      this.T = null

      let url = ''
      if (index === 1) {
        // 支付宝二维码
        this.showAliQrcode = true
        this.showWechatQrcode = false
        url = this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode'
      } else {
        // 微信二维码
        this.showWechatQrcode = true
        this.showAliQrcode = false
        url = this.$baseUrl + 'ebook/purchase/v3/h5WeChatPayOrderQrCode'
      }
      // 支付宝生成订单（网站）
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: url,
        body: {
          userId: this.$getUserInfo().id,
          productId: this.selectedProduct.id,
          name: this.customName,
          idNumber: this.customNo,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          if (index === 1) {
            this.showQrcodeLoading = false
            // this.showAliQrcode = false
            this.currentOrder = res.resultData
            this.$nextTick(() => {
              this.creatQrCode(res.resultData.qrCodeLink)
            })
            this.loopOrderState(res.resultData.outTradeNo)
          } else {
            this.showQrcodeLoading = false
            // this.showWechatQrcode = false
            this.currentOrder = res.resultData
            this.$nextTick(() => {
              this.creatQrCode(res.resultData.qrCodeLink)
            })
            this.loopOrderState(res.resultData.outTradeNo)
          }
        }
      })
    },
    onContentChange () {
      if (!this.customNo) {
        this.contentTips = '* 请输入身份证号'
        return
      }
      if (!this.isValidChineseID(this.customNo)) {
        this.contentTips = ('* 身份证号码格式不正确')
        return
      }
      if (!this.isAgeGreaterThan16(this.customNo)) {
        this.contentTips = ('* 不满18周岁禁止自主购买')
        return
      }
      this.contentTips = ''
    },
    getProduct () {
      // 获取产品信息
      const _this = this
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: this.$baseUrl + 'ebook/purchase/v3/getProduct',
        body: {
          // 1：学生端 2：教师端
          tag: 2,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.productData = res.resultData
          _this.selectedProduct = _this.productData[0]
          _this.selectedText = _this.productData[0].name
          _this.getPurchaseUserInfo()
        }
      })
    },
    getPurchaseUserInfo () {
      // 保存或修改购买用户信息
      const _this = this
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: this.$baseUrl + 'ebook/purchase/v3/getPurchaseUserInfo',
        body: {
          userId: this.$getUserInfo().id,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.customNo = res.resultData.idNumber
          _this.customName = res.resultData.name
          _this.onContentChange()
        }
      })
    },
    checkCode (id) {
      // 轮询支付状态（网站）
      const _this = this

      let url = ''
      if (this.payType === 1) {
        url = this.$baseUrl + 'ebook/purchase/v3/h5AlipayPollingQueryOrder'
      } else {
        url = this.$baseUrl + 'ebook/purchase/v3/h5WechatPollingQueryOrder'
      }
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: url,
        body: {
          outTradeNo: id,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.$message.success('支付成功')
          _this.buyVisibles = false
          _this.buyClose()
          _this.getBooks()
          // 购买成功，会创建学生角色信息，本地访问服务，刷新用户角色信息
          _this.getPublicSecret()
        }
      })
    },
    loopOrderState (id) {
      // 轮询当前订单状态s
      this.T = setInterval(() => {
        this.checkCode(id)
      }, 3000)
    },
    creatQrCode (id) {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(id)
        return
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: id, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    isAgeGreaterThan16 (idNumber) {
      // 假设身份证号码是18位，第7到14位是出生年月日
      const birthday = idNumber.substring(6, 14)
      const now = new Date()
      const year = now.getFullYear()
      const birthYear = parseInt(birthday.substring(0, 4), 10)

      // 计算当前年份与出生年份的差值
      const age = year - birthYear

      // 判断年龄是否大于16岁
      return age > 18
    },
    isValidChineseID (id) {
      if (id?.length !== 18) {
        return false
      }

      // 身份证号码前17位必须是数字
      if (!/^\d{17}$/.test(id.substr(0, 17))) {
        return false
      }

      // 验证年份、月份和日期
      const year = id.substr(6, 4)
      const month = id.substr(10, 2)
      const day = id.substr(12, 2)
      const date = new Date(year, month - 1, day)
      if (date.getFullYear() !== parseInt(year) || date.getMonth() !== parseInt(month) - 1 || date.getDate() !== parseInt(day)) {
        return false
      }

      // 验证校验码
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      const codes = '10X98765432'
      let sum = 0
      for (let i = 0; i < id.length - 1; i++) {
        sum += parseInt(id[i]) * weights[i]
      }
      const remainder = sum % 11
      if (codes[remainder] !== id[17].toUpperCase()) {
        return false
      }

      return true
    },
    getPublicSecret () {
      // 获取加密公钥
      const _this = this
      const param = {}
      this.$http.getAuth(this.$loginServer + 'auth/res/getPublicSecret', param).then(res => {
        console.log(res)
        if (res) {
          // 获取加密公钥
          _this.encryptionKey = res.data.resultData
          _this.getUserInfoByUserId()
        }
      })
    },
    getUserInfoByUserId () {
      // 刷新个人信息
      const param = {
        userId: this.$getUserInfo().id
      }
      const authUtils = new AuthUtils(this.encryptionKey)
      const keyBase64 = authUtils.generateRandomKey()
      const key = authUtils.encryptKey(keyBase64)
      const data = authUtils.aesEncrypt_EBC(JSON.stringify(param), keyBase64)

      const encrypParam = {}
      encrypParam.encryptionKey = key
      encrypParam.encryptionData = data
      encrypParam.access_token = this.access_token

      this.$fetch({
        url: this.$loginServer + 'auth/res/encrypt/getUserInfoByUserId',
        body: encrypParam
      }).done((res) => {
        if (res && res.resultData) {
          // 解密参数
          const jsonString = authUtils.aesDecrypt_EBC(res.resultData.encryptionData, keyBase64)
          const decryptedData = JSON.parse(jsonString)
          console.log('decryptedData', decryptedData)
          console.log('decryptedData-roleList', decryptedData.roleList)
          setUserInfo(
            Object.assign(decryptedData, {
              user: []
            })
          )
          // this.$router.go(0);
        }
      })
    }
  }
}

</script>

<style lang="less" scoped>
/* 顶部课文搜索 + 下方（左课本 | 右目录） */
@booksindex-search-block: 100px;

.booksindex-content {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
  width: 100%;

  &.ml-190 {
    margin-left: -190px;
    width: calc(100% + 190px);
  }

  &.ml-0 {
    margin-left: -60px;
    width: calc(100% + 60px);
  }
}

.booksindex-lesson-search {
  flex-shrink: 0;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 60;
  margin-bottom: 12px;
  padding: 14px 20px;
  background: #fff;
  border-radius: @border-radius-base;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  .booksindex-lesson-search-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 16px;
    width: 100%;
    min-width: 0;
  }

  .booksindex-lesson-search-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1 320px;
    min-width: 0;
  }

  .booksindex-lesson-search-input {
    flex: 1;
    min-width: 0;
  }

  .booksindex-lesson-search-btn {
    flex-shrink: 0;
  }

  .booksindex-lesson-search-history {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 10px;
    flex: 1 1 240px;
    min-width: 0;
    justify-content: flex-end;
  }

  .booksindex-lesson-search-history-label {
    font-size: 14px;
    color: #666;
    flex-shrink: 0;
  }

  .booksindex-lesson-search-history-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .booksindex-history-tag {
    display: inline-flex;
    align-items: center;
    max-width: 180px;
    padding: 2px 4px 2px 10px;
    font-size: 13px;
    color: #333;
    background: #f0f0f0;
    border-radius: 12px;
    line-height: 22px;
  }

  .booksindex-history-tag-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      color: @primary-color;
    }
  }

  .booksindex-history-tag-close {
    flex-shrink: 0;
    margin-left: 2px;
    padding: 2px 4px;
    font-size: 10px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #666;
    }
  }

  .booksindex-history-clear {
    flex-shrink: 0;
    font-size: 14px;
    color: #666;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      color: @primary-color;
    }
  }

  .booksindex-lesson-search-dropdown {
    position: absolute;
    left: 20px;
    right: 20px;
    top: 100%;
    margin-top: 6px;
    width: auto;
    max-height: 280px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: @border-radius-base;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    z-index: 70;
    padding: 8px 0;
  }

  .booksindex-lesson-search-spin {
    display: block;
    text-align: center;
    padding: 16px;
  }

  .booksindex-lesson-search-label {
    font-size: 12px;
    color: #999;
    padding: 4px 16px 8px;
  }

  .booksindex-lesson-search-item {
    padding: 10px 16px;
    cursor: pointer;
    line-height: 1.5;

    &:hover {
      background: #f5f5f5;

      .booksindex-lesson-search-item-title {
        color: @primary-color;
      }
    }
  }

  .booksindex-lesson-search-item-body {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px 10px;
  }

  .booksindex-lesson-search-item-title {
    font-size: 15px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .booksindex-lesson-search-item-meta {
    font-size: 13px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
  }

  .booksindex-lesson-search-empty {
    padding: 12px 16px;
    color: #999;
    font-size: 14px;
  }
}

.booksindex-main {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
}

.imagelist {
  width: 200px;
  min-width: 200px;
  //height: 320px;
  background-color: @white;
  border-radius: @border-radius-base;
  height: calc(100vh - 125px - @booksindex-search-block);
  // margin-top: 10px;
  // display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 20px; //用于左箭头
  position: sticky;
  top: 0;
  align-self: flex-start;
  flex-shrink: 0;
  overflow: auto;
  //float: left;

  .ImageItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 20px;

    .book-name {
      display: flex;
      justify-content: center;
      justify-content: center;
      margin-top: 10px;
    }

    .book-name-select {
      font-weight: bold;
      font-size: 18px;
    }
  }

  .normal {
    border-radius: @border-radius-base;
    width: 100px;
    height: 130px;
    cursor: pointer;
  }

  .big {
    width: 130px;
    height: 180px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  }

  .locked {
    opacity: 0.6;
  }

  .lockgray {
    filter: contrast(0.4);
  }

  .lock {
    opacity: 1;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
  }

  .biglock {
    opacity: 1;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
  }
}

.catalog {
  //margin-top: 340px;
  //width: calc(100vw - 340px);
  flex: 1;
  min-width: 0;
  height: calc(100vh - 125px - @booksindex-search-block);
  background-color: white;
  border-radius: @border-radius-base;
  padding: 25px;
  position: relative;

  //flex: 1;
  //float: right;

  .catalog-title {
    height: 40px;
    border-bottom: 1px solid #ececec;

    .catalog-text {
      float: left;
      width: 56px;
      height: 26px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 26px;

    }

    .catalog-style {
      position: absolute;
      right: 35px;
      display: flex;
      justify-content: space-between;

      .list {
        width: 25px;
        height: 25px;
        background-image: url("../../assets/image/catalog_list.png");
        background-size: cover;
        background-position: center;
      }

      .rectangle {
        width: 25px;
        height: 25px;
        margin-left: 10px;
        background-image: url("../../assets/image/catalog_rectangle.png");
        background-size: cover;
        background-position: center;
      }
    }
  }

  // 列表
  .catalog-content {
    padding-top: 25px;
    padding-left: 50px;
    padding-right: 50px;
    height: calc(100vh - 200px - @booksindex-search-block);
    overflow: scroll;

    .catalog-content-i {
      height: 45px;
      font-size: 16px;
      font-family: 'PingFangSC-Regular', 'Arial Narrow', Arial, sans-serif;
      color: #000000;
      line-height: 220%;
      position: relative;
      border-bottom: 1px solid #ececec;
      margin-top: 8px;
    }

    .title {
      font-size: 20px;
      font-family: 'PingFangSC-Regular', 'Arial Narrow', Arial, sans-serif;
      color: #db5647;
      // cursor: not-allowed;
    }

    .isClickable {
      cursor: pointer;
      padding-left: 10px;
      white-space: pre-wrap;

      &:hover {
        color: @primary-color;
      }
    }

    .disabled {
      color: @disabled-color;
      // cursor: not-allowed;
    }

    .disabledxxx {
      color: @primary-color;
      font-size: 18px;
    }

    .card-video {
      background-image: url('../../assets/image/book-video.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 25px;
      width: 25px;
      float: right;
      margin-top: 10px;
      cursor: pointer;
    }

    .card-herf {
      background-image: url('../../assets/image/book-herf.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 25px;
      width: 25px;
      float: right;
      margin-right: 10px;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  //矩阵
  .catalog-list {
    padding-top: 25px;
    background-color: #FFFFFF;
    height: calc(100vh - 200px - @booksindex-search-block);
    overflow-y: scroll;
    overflow-x: hidden;

    .card {
      background-image: url('../../assets/image/book_unit.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .card2 {
      background-image: url('../../assets/image/book_unit2.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .card3 {
      background-image: url('../../assets/image/book_unit3.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .card-video {
      background-image: url('../../assets/image/book-video.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 25px;
      width: 25px;
      float: right;
      //cursor: all-scroll;
    }

    card-video:hover {
      cursor: pointer;
    }

    .card-herf {
      background-image: url('../../assets/image/book-herf.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 25px;
      width: 25px;
      margin-right: 10px;
      float: left;
      // cursor: default;
    }

    card-herf:hover {
      cursor: pointer;
    }

    .isClickable {
      cursor: pointer;
      white-space: pre-wrap;
      font-size: 16px;

      &:hover {
        color: @primary-color;
      }
    }

    .disabled {
      color: @disabled-color;
      cursor: not-allowed;
    }

    .disabledxxx {
      // color: #db5647;
    }

  }
}

.img_1 {
  margin: auto;
  margin-left: 5px;
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.dialog {
  background-color: white;
  border-radius: @border-radius-base;
  // margin: 0 50px;
}

.dialog-content-title {
  font-family: 'STSongti-SC-Black';
  font-size: 22px;
  font-weight: bolder;
  height: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-content-title-i {
  font-family: 'STSongti-SC-Black';
  font-weight: bolder;
  font-size: 18px;
  height: 44px;
  color: @primary-color;
  background-color: #eef4fd;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-content-ii {
  padding: 30px 50px;
  font-family: 'STSongti-SC-Black';
  font-size: 18px;
  background-color: @white;
}

.dialog-content-ii p {
  text-indent: 2em;
  line-height: 2em;
}

.open {
  width: 44px;
  height: 44px;
  cursor: pointer;
}

/deep/ .ant-modal-content {
  //background-color: #f1f0f0;
  border-radius: 10px;
  min-height: 620px;

  // overflow-y: auto;
}

/deep/ .ant-modal-title {
  font-size: 18px;
  color: #000000;
  font-family: 'PingFangSC-Medium';
}

/deep/ .ant-modal-header {
  //background-color: #f1f0f0;
  //border-radius: 10px;

}

/deep/ .ant-modal-body {
  padding: 12px 24px;
}

/deep/ .ant-card-head-title {
  color: @primary-color;
  //text-align: center;
  //tab-size: 18px;
  font-size: 18px;
}

/deep/ .ant-card-body {
  min-height: 310px;
  tab-size: 16px;
}

/deep/ .ant-card-body {
  tab-size: 16px;
}

.tabTitle {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}

.d-table {
  text-align: center;

  .no-data {
    text-align: center;
    margin-top: 60px;
  }

}

.top {
  height: 500px;
  overflow: scroll;
}

.imagelist::-webkit-scrollbar-thumb {
  background-color: transparent;
}

/* 设置全局滚动条样式 */
.imagelist:hover::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度 */
}

::-webkit-scrollbar-track {
  background: transparent; /* 滚动条背景颜色 */
}

::-webkit-scrollbar-thumb {
  background: rgb(191 191 191); /* 滚动条滑块颜色 */
}

::-webkit-scrollbar-thumb:hover {
  background: transparent; /* 滚动条滑块悬停时颜色 */
}

.qrcode-content {
  height: 100px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.buy-title {
  font-weight: bold;
  color: #000000;
}

.buy-content {

}

.buy-info {
  background: #ebebeb;
  border-radius: 10px;
  padding: 10px 10px 10px 0px;

  .info-container {
    display: flex;
  }

  .left-div {
    flex: 1; /* 左边占据1份空间 */
    padding: 20px; /* 内边距，可以根据需要调整 */

    .info-img {
      height: 170px;
      width: auto;
      display: block;
      object-fit: cover;
      border-radius: 10px;
      margin: auto
    }
  }

  .right-div {
    flex: 5; /* 右边占据2份空间 */
    display: flex;
    flex-direction: column; /* 竖直排列 */
  }

  .top-div {

    text-align: right;
  }

  .middle-div {
    margin-top: 10px;
    margin-right: 20px;
    text-align: right;
    display: flex;
    justify-content: space-between;

    .info-price {
      font-size: 18px;
      font-weight: bolder;
      color: #fa5542;
    }
  }

  .bottom-div {

    text-align: left;
  }
}

.buy-img {
  width: 130px;
  height: 50px;
}

.info-status {
  padding: 2px 3px; /* 内边距 */
  //margin: 2px; /* 外边距 */
  // background-color: #ffdddd; /* 背景颜色 */
  text-align: right;
  font-size: 12px;
  border-radius: 20px; /* 圆角的半径 */
  margin-left: 20px;
  margin-right: 20px;
  padding: 2px 8px;
  border: 1px solid dodgerblue; /* 边框宽度和颜色 */
  color: dodgerblue;
}

.info-must {
  color: #fa5542;
  text-align: center;
  margin: auto 0px;
}

.info-title {
  width: 90px;
  font-weight: bolder;
  margin: auto;
  text-align-last: justify
}

.info-tips {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 6px;
  top: 8px;
}

.a-menu-item {
  color: #FFFFFF;
}

.a-menu-item:hover {
  background-color: #000000; /* 灰色的背景 */
}

/deep/ .ant-statistic-content-prefix {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

/deep/ .ant-statistic-content-value {
  color: #fa5542;
  font-size: 16px;
}

/deep/ .ant-statistic-content-suffix {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

///deep/.ant-modal-body {
//  max-height: calc(80vh - 50px);
//  overflow-y: auto;
//  &::-webkit-scrollbar {
//    width: 6px;
//    /*高宽分别对应横竖滚动条的尺寸*/
//    height: 1px;
//  }
//
//  &::-webkit-scrollbar-thumb {
//    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//    background: #e3e3e6;
//    border-radius: 6px;
//  }
//
//  &::-webkit-scrollbar-track {
//    background: transparent;
//    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//    border-radius: 5px;
//  }
//}
</style>
